import { render } from "./SwapLessons.vue?vue&type=template&id=4d640b19&ts=true"
import script from "./SwapLessons.vue?vue&type=script&lang=ts"
export * from "./SwapLessons.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/trend/MANARATFOUNDATION/KRC-FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__